import map from 'lodash/map';
import { DRIVER_LICENSE_ATTR } from '@yme/common/constants';
import { ENABLED_FOR_TEST_RIDE_ATTR, PRODUCT_YEAR_ATTR } from '@yme/common/selectors';
import { CATEGORY_ID_PLACEHOLDER, IN_RIVER_ID_TEST_RIDE, } from '@yme/components/TestRide/components/TestRideGrid/constants';
import { DEFAULT_MOTORCYCLES_EXTRA_ATTRS_EN } from '@yme/selectors/constants';
import { getAttributeByName } from '@yme/utils/common';
import { getInRiverId, getLatestModelTitle } from '@yme/utils/product';
export function isTestRideGridEmpty(props) {
    return !props || !props.hyperdriveEndpoints || !props.googleApiKey;
}
export function getPreparedCardsData({ data }) {
    return data.reduce((acc, product) => {
        const { id, name, sku, latestModel, attributes, categories, image, groupedProductMasterVariantSku, groupingProducts, } = product;
        const productYearAttr = attributes.find((attribute) => attribute.name === PRODUCT_YEAR_ATTR);
        const productYear = productYearAttr?.value ?? '';
        const isTestRideAvailableCT = getAttributeByName(attributes, ENABLED_FOR_TEST_RIDE_ATTR);
        const inRiverIdKey = attributes.find((attribute) => attribute.name === IN_RIVER_ID_TEST_RIDE);
        const inRiverIds = map(map(categories, (cat) => getInRiverId(cat.key)), (key) => ({
            key,
        }));
        const driverLicense = attributes.find((attribute) => attribute.name === DRIVER_LICENSE_ATTR);
        const nameWithYear = getLatestModelTitle({
            isLatestModel: latestModel ?? false,
            name,
            productYear,
        });
        const inRiverId = getInRiverId(inRiverIdKey?.value || '');
        const imageData = {
            url: image?.url,
            label: image?.label,
            width: image?.dimensions?.width,
            height: image?.dimensions?.height,
        };
        const isYAMTTransmission = groupingProducts.some((item) => {
            return item.variants.some((variant) => variant?.productMotorcycleTransmission?.en ===
                DEFAULT_MOTORCYCLES_EXTRA_ATTRS_EN.yAMTTransmission);
        });
        acc[sku] = {
            id,
            name: nameWithYear,
            image: imageData,
            inRiverId,
            inRiverIds,
            sku,
            groupedProductMasterVariantSku,
            driverLicense: driverLicense?.value ?? [],
            isTestRideAvailableCT,
            isYAMTTransmission,
        };
        return acc;
    }, {});
}
export const getProductsSkus = (productData) => {
    return productData.reduce((acc, product) => {
        acc[product.sku] = product.sku;
        product.variants.forEach((variant) => {
            acc[variant.sku] = product.sku;
        });
        return acc;
    }, {});
};
export const getMainModelForSelected = (selected, units) => {
    const mainModels = selected.map((model) => units[model]);
    return [...new Set(mainModels)];
};
export const getTestRideEndpoint = (endpoint, categoryId) => {
    return endpoint.replace(CATEGORY_ID_PLACEHOLDER, categoryId);
};
export const getFilteredByMasterSkuProducts = ({ allProductsData, testRideProducts, masterData, }) => {
    return allProductsData.filter((product) => {
        if (typeof testRideProducts !== 'undefined' && Array.isArray(testRideProducts)) {
            return product?.sku && masterData.includes(product.sku);
        }
        return false;
    });
};
export const getEnableTestRideProducts = (data) => {
    return Object.keys(data).reduce((acc, key) => {
        if (data[key].isTestRideAvailableCT) {
            acc.push(data[key]);
        }
        return acc;
    }, []);
};
export const getMasterProductUniqueTestRideProducts = (productsList, masterVariationsCardsData) => {
    const testRideList = productsList.reduce((acc, item) => {
        if (item.groupedProductMasterVariantSku === null) {
            acc.push(item);
        }
        else if (masterVariationsCardsData[item.groupedProductMasterVariantSku]) {
            acc.push(masterVariationsCardsData[item.groupedProductMasterVariantSku]);
        }
        else {
            acc.push(item);
        }
        return acc;
    }, []);
    const uniqueMap = new Map();
    testRideList.forEach((item) => {
        uniqueMap.set(item?.sku, item);
    });
    return Array.from(uniqueMap.values());
};
